import { filtersHelper } from '@/utils';
import { requestLogModel } from '@/models/api/requestLog.model';

export const servedeckLogModel = (data) => ({
    uuid: data.uuid,
    method: data.method,
    action: data.action,
    url: data.url,
    requestPayload: data.request_payload,
    responsePayload: data.response_payload,
    errorMessage: data.error_message,
    statusCode: data.status_code,
    success: data.success,
    durationMs: data.duration_ms,
    createdAt: filtersHelper.getDateTimeFormat(data.created_at),
    updatedAt: filtersHelper.getDateTimeFormat(data.updated_at),
    requestLog: data.request_log ? requestLogModel(data.request_log) : null,
});